import { useMemo } from 'react'
import { CELL_HEIGHT } from '../constants'

const HEADER_HEIGHT = 48

export function useEffectiveSlotHeight(
  containerHeight: number,
  timeSlotCount: number,
): number {
  return useMemo(() => {
    if (containerHeight === 0 || timeSlotCount === 0) {
      return CELL_HEIGHT
    }

    const availableHeight = containerHeight - HEADER_HEIGHT
    const minTotalHeight = timeSlotCount * CELL_HEIGHT

    // If we have more space than the minimum, distribute it
    if (availableHeight >= minTotalHeight) {
      return availableHeight / timeSlotCount
    }

    // Otherwise use the minimum
    return CELL_HEIGHT
  }, [containerHeight, timeSlotCount])
}
